import React, { PureComponent } from 'react';
import Portal from '../../Portal';
import MicroLearningModal from '../../../components/MicroLearningDetailsModal'
import ImageApi from '../../../api/image';
import { TranslateApi } from '../../../api';

class FeedLearningItem extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      imageUrl: '',
      isTranslated: false,
      name: props.item.post.name,
      title: 'There is a new micro learning module available',
      timeText: 'Time to complete:',
      buttonText: 'START LEARNING',
      completedText: 'Completed',
    };
  }

  componentDidMount() {
    if (this.props.item.post.image.url) {
      ImageApi.getImage(this.props.item.post.image.url).then(imageUrl => {
        this.setState({ imageUrl });
      });
    }
  }

  handleLearningModal = (value) => {
    this.setState({
      isLearningModal: value
    })
  }

  onTranslateClicked = async () => {
    let translatedTitle, translatedButtonText, translatedTimeText, translatedName, translatedCompletedText;
    const { title, buttonText, timeText, name, isTranslated, completedText } = this.state;

    this.setState({
      isTranslated: !isTranslated
    })

    if (isTranslated) {
      this.setState({
        title: 'There is a new micro learning module available',
        timeText: 'Time to complete:',
        buttonText: 'START LEARNING',
        completedText: 'Completed',
        name: this.props.item.post.name
      })

      return null
    }

    if (this.props.currentUser.language_id) {
      const resultTitle = await TranslateApi.getTranslation(this.props.currentUser.language_id, title)
      if (resultTitle && resultTitle.success) {
        translatedTitle = resultTitle.data
      }
  
      const resultTimeText = await TranslateApi.getTranslation(this.props.currentUser.language_id, timeText)
      if (resultTimeText && resultTimeText.success) {
        translatedTimeText = resultTimeText.data
      }

      const resultButtonText = await TranslateApi.getTranslation(this.props.currentUser.language_id, buttonText)
      if (resultButtonText && resultButtonText.success) {
        translatedButtonText = resultButtonText.data
      }

      const resultName = await TranslateApi.getTranslation(this.props.currentUser.language_id, name)
      if (resultName && resultName.success) {
        translatedName = resultName.data
      }

      const resultCompletedText = await TranslateApi.getTranslation(this.props.currentUser.language_id, completedText)
      if (resultCompletedText && resultCompletedText.success) {
        translatedCompletedText = resultCompletedText.data
      }
  
      if (!translatedName || !translatedCompletedText || !translatedButtonText || !translatedTimeText || !translatedTitle) {
        this.props.addAlertToAlerts({
          title: 'Message',
          message: 'Translation to your selected language is not currently available.',
          confirmBtnText: 'Okay',
        });

        this.setState({
          isTranslated: false
        })
      } else {
        this.setState({
          title: translatedTitle,
          timeText: translatedTimeText,
          buttonText: translatedButtonText,
          completedText: translatedCompletedText,
          name: translatedName
        })
      }
    } else {
      this.props.addAlertToAlerts({
        title: 'Message',
        message: 'User does not have a language configured.',
        confirmBtnText: 'Okay',
      });

      this.setState({
        isTranslated: false
      })
    }
  }

  render() {
    const { item } = this.props;
    const { name, image, points, time_to_complete, completed, completedText } = item.post;
    const { isLearningModal, title, buttonText, timeText } = this.state;

    return (
      <React.Fragment>
      <div className="feed-item-content">
        <p className="feed-item-content-text pt-3">{title}</p>
        <div className="d-flex feed-item-event-block">
          {image.url && (
            <div className="feed-item-event-image-holder">
              {this.state.imageUrl && (
                <img className="feed-item-event-image" src={this.state.imageUrl} />
              )}
            </div>
          )}

          <div className="feed-item-event-info-holder flex-column">
            <div className="d-flex flex-row flex-grow-1  justify-content-between pl-3">
              <div className="flex-column">
                <p className={"feed-item-event-info-title"}>{name}</p>
                {!completed ? (
                  <span className="feed-item-content-text">{timeText}<span className="time">{` ${time_to_complete} ${time_to_complete > 1 ? 'mins' : 'min'}`}</span></span>
                ) : (
                  <p className="time">{completedText}</p>
                )}
              </div>
              <div className="justify-content-end">
                <div className="learning-item--points">
                  {points}
                </div>
              </div>
            </div>   
            {!completed ? (
              <div className="feed-item-event-info-button"onClick={
                !completed
                  ? () => {
                    this.handleLearningModal(true);
                    }
                  : null
                }>
                {buttonText}
              </div>)
            : null
            }
          </div>
        </div>
      </div>
      <Portal
        hide={() => {this.handleLearningModal(!isLearningModal);}}
        isOpen={isLearningModal}
      >
      <MicroLearningModal learningItem={item.post} learningAvatar={this.state.imageUrl} hide={() => this.handleLearningModal(false)} />
    </Portal>
    <div className="feed-item-footer d-flex w-100 justify-content-end m-0 p-0 pr-3" style={{cursor: 'pointer'}} onClick={this.onTranslateClicked}>
        <p>{`${this.state.isTranslated ? "Show original" : "Translate this"}`}</p>
      </div>
    </React.Fragment>
    );
  }
}

export default FeedLearningItem;
